export default "__VITE_ASSET__B3LY9QwQ__"